import State from './types'

const initialState: State = {
    userDetails: {
        isLoading: false,
        error: null,
        transport: null,
    },
}

export default initialState
